<div>
    <div>
        <div class="pb-3 pt-4 text-xlarge">Download the worksheet as a:</div>
        <div class="d-flex flex-column ">
            <a role="button" class="btn btn-primary col" href="https://docs.google.com/spreadsheets/d/1rVuZ2hYM4uvMOSS2QEosG3p7v8pVdPIo7q2FlAd5BwQ/edit#gid=0" target='_blank'>Google Spreadsheet</a>
            <a role="button" class="btn btn-primary col mt-2" href="https://drive.google.com/file/d/1okAQ9sodawnT2Z3DZZD_gABWKPE3Tfcd/view?usp=sharing" target='_blank'>Csv Spreadsheet</a>
        </div>
    </div>
</div>